import React from 'react';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import styles from './userHome.styles';

const actionButtons = [
  {
    condition: (_, __, ___, ____, isLoading) => isLoading,
    label: 'Loading',
    link: '',
    isLoading: true,
  },
  {
    condition: (_, sampleJob) => !sampleJob?.jobId,
    label: 'Get Started with A + B',
    link: '/docs#a_b',
  },
  {
    condition: (_, __, noJobRuns) => noJobRuns,
    label: 'Run a GPU job',
    link: '/docs#devices',
  },
  {
    condition: (_, __, ___, allValuesAreEmpty) => !allValuesAreEmpty,
    label: 'Run a quantum job',
    link: '/docs#quantum_coin_toss',
  },
];

const ActionButton = ({
  navigate, sampleJob, noJobRuns, allValuesAreEmpty, isLoading,
}) => {
  const buttonConfig = actionButtons.find(({
    condition,
  }) => condition(navigate, sampleJob, noJobRuns, allValuesAreEmpty, isLoading));

  if (!buttonConfig) return null;

  if (buttonConfig.isLoading) {
    return (
      <LoadingButton
        loading
        loadingPosition="end"
        endIcon={<div />}
        variant="contained"
        sx={{ ...styles.button, padding: '12px 36px' }}
      >
        {buttonConfig.label}
      </LoadingButton>
    );
  }

  return (
    <Box sx={{ display: 'flex', paddingLeft: '70px' }}>
      <Button type="primary" variant="contained" sx={styles.button} onClick={() => navigate(buttonConfig.link)}>
        {buttonConfig.label}
      </Button>
    </Box>
  );
};

export default ActionButton;
